/* eslint-disable */
import React from "react";
import { Coins, Building2, ShieldAlert } from "lucide-react";

/**
 * Operator-facing clarifier strip used on both `/admin/assospay` and
 * `/admin/assospay/reports`. Reinforces three invariants that the
 * AssosPay platform commits to:
 *
 *   1. ARC source of truth lives in AssosPay (we mint, we account, we
 *      audit) — not the partner.
 *   2. Assos365 only ever receives EUR credits from redemptions; no USD
 *      and no ARC token is ever transferred to the partner.
 *   3. ARC transfer/send (peer-to-peer or admin movement) is NOT
 *      enabled yet — this is read-only visibility for now.
 *
 * Display-only. No network call. Hardcoded copy. Hidden behind no
 * authentication beyond what the page itself already requires.
 */
export default function DataSourcesBanner() {
  return (
    <div
      data-testid="admin-data-sources-banner"
      className="rounded-md border border-[#00F0FF]/25 bg-[#00F0FF]/5 p-4 grid grid-cols-1 md:grid-cols-3 gap-3"
    >
      <div className="flex items-start gap-2" data-testid="banner-source-arc">
        <Coins className="h-4 w-4 text-[#00F0FF] mt-0.5 flex-shrink-0" />
        <div className="font-mono text-[11px] text-white/75 leading-relaxed">
          <span className="text-[#00F0FF] font-bold">ARC source of truth: AssosPay.</span>{" "}
          ARC holdings, balances, and redemption state are tracked here.
        </div>
      </div>
      <div className="flex items-start gap-2" data-testid="banner-source-partner">
        <Building2 className="h-4 w-4 text-[#00F0FF] mt-0.5 flex-shrink-0" />
        <div className="font-mono text-[11px] text-white/75 leading-relaxed">
          <span className="text-[#00F0FF] font-bold">Assos365 receives EUR credit only.</span>{" "}
          No USD, no ARC token movement to the partner.
        </div>
      </div>
      <div className="flex items-start gap-2" data-testid="banner-source-transfer">
        <ShieldAlert className="h-4 w-4 text-[#FFB800] mt-0.5 flex-shrink-0" />
        <div className="font-mono text-[11px] text-white/75 leading-relaxed">
          <span className="text-[#FFB800] font-bold">ARC transfer/send is not enabled yet.</span>{" "}
          Backlog item <code>AP-6A</code>; this dashboard is read-only.
        </div>
      </div>
    </div>
  );
}
